// extracted by mini-css-extract-plugin
module.exports = {"nav_link":"nav_link-2nKXnmjR"};